import Model from "./Model";

export const defaultTrainingBudget: ITrainingBudget = {
  id: "",
  type: "",
  totalAmount: 0,
  available:0
};

export interface ITrainingBudget {
  id: string;
  type: string;
  totalAmount:number
  available:number
}

export default class TrainingBudget extends Model<ITrainingBudget> {

  update(): void {

  }

  edit(): void {}

  async remove() {
    if (!window.confirm("Continue to delete?")) return;
  }
}
